<template>
  <div>
    <div class="page-title">
      {{ $t('menu.customer_service_ticket_list') }}
    </div>
    <div class="ticket-list page-container">

      <div class="filter-right-container">
        <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div>
        <el-popover
          placement="bottom"
          trigger="click"
        >
          <div class="filter-section-container">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('components.create_time') }}</div>
                <el-date-picker
                  v-model="search.period"
                  class="filter-item-value"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('components.status') }}</div>
                <el-select v-model="search.status" class="filter-item-value" clearable>
                  <el-option
                    v-for="(item,index) in csTicketStatusMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.business_type') }}</div>
                <el-select v-model="search.operation_type" class="filter-item-value" clearable>
                  <el-option
                    v-for="(item,index) in merchantProductMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.customer_phone_number') }}</div>
                <el-input v-model.trim="search.phone_no" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
                <el-input v-model="search.merchant_order_id" type="text" class="filter-item-value" clearable />
              </div>
              <!-- <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.payment_code') }}</div>
              <el-input v-model="search.account_no"  type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.qr_link') }}</div>
              <el-input v-model.trim="search.qr_link"  type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.qr_code_id') }}</div>
              <el-input v-model.trim="search.qrcode"  type="text" class="filter-item-value" clearable />
            </div> -->

              <div class="filter-item" />
            </div>
            <div class="filter-operate">
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>
          <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
        </el-popover>
        <el-button class="mb-10 mr-12" plain :loading="downloading" :disabled="downloading" type="info" @click="onClickDowmloadBtn"><svg-icon icon-class="download" /> {{ $t('components.download') }}</el-button>
        <el-button type="primary" class="filter-btn-add mb10 " @click="onClickAddBtn"> <i style="font-weight: 600" class="el-icon-plus" /> {{ $t('components.add') }}</el-button>
      </div>

      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
          class="tableContainer"
        >
          <el-table-column :label="$t('customerService.work_order_number')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.issue_no }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.merchant_order_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('customerService.business_type')" align="center">
            <template slot-scope="scope">
              <span>{{ getBusinessTypeLabel(scope.row.operation_type) }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('customerService.account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no }}</span>
          </template>
        </el-table-column> -->

          <el-table-column key="amount" :label="$t('components.amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('customerService.customer_phone_number')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone_no | strAesDecryptAndAsterisk }}</span>
          </template>
        </el-table-column> -->

          <el-table-column :label="$t('components.transaction_date')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_date }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('customerService.issue')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.issue }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.conclusion')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.conclusion }}</span>
          </template>
        </el-table-column> -->

          <el-table-column :label="$t('components.create_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.status')" min-width="170" align="center">
            <template slot-scope="scope">
              <el-tag class="tag-custom" style="min-width: 120px" :type="getTicketStatusStyle(scope.row.status)">{{ getTicketStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.operation')" align="center" min-width="130">
            <template slot-scope="scope">
              <el-button type="info" size="small" plain @click="onClickDetailBtn(scope.row)">
                {{ $t('components.view_details') }}
              </el-button>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
      <AddTicketModal ref="addTicketRef" @updateList="getTicketList" />
      <TicketDetailsModal ref="ticketDetailsModalRef" :detail-id="detailId" />
      <ReOpenReply ref="reOpenReplyModal" :detail-id="detailId" @updateList="onClickPaginator" />
    </div>
  </div>
</template>

<script>

import { fetchTicketList, fetchDownloadTicketList } from '@/api/customer-service/customer-service'
import { csTicketStatusMap, merchantProductMap, ticketPaymentMethodMap } from '@/utils/maps'
import { appointDate } from '@/utils/index'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
export default {
  name: 'Ticket_List',
  components: {
    Paginator: () => import('@/views/components/Paginator.vue'),
    AddTicketModal: () => import('./components/Modal/AddTicketModal'),
    TicketDetailsModal: () => import('./components/Modal/TicketDetailsModal'),
    ReOpenReply: () => import('./components/Modal/ReOpenReply')
  },
  props: {
    typeNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      detailId: 0,
      showFilterContent: true,
      search: {
        institute_id: '',
        period: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59']
      },
      tableData: [],
      csTicketStatusMap: csTicketStatusMap(),
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },

  computed: {
    getTicketStatusStyle() {
      return function(value) {
        return csTicketStatusMap(value).type
      }
    },
    getTicketStatusLabel() {
      return function(value) {
        return csTicketStatusMap(value).label
      }
    },
    merchantProductMap() {
      return merchantProductMap()
    },
    // getInstituteName() {
    //   return function(id) {
    //     const instituteItem = this.instituteCategoryArr.find(item => item.id === id) || []
    //     return instituteItem.institute_name
    //   }
    // },
    getBusinessTypeLabel() {
      return function(value) {
        return merchantProductMap(value).label
      }
    },
    getPaymentMethodLabel() {
      return function(value) {
        if (!value) {
          return '--'
        }
        return ticketPaymentMethodMap(value).label
      }
    }
  },
  // watch: {
  //   typeNum: function() {
  //     this.getTicketList()
  //   }
  // },
  created() {
    this.getTicketList()
    // this.getInstituteList()
  },
  methods: {
    // 获取渠道机构
    // getInstituteList() {
    //   // const params = { institute_type: }
    //   fetchInstituteList().then(res => {
    //     if (res.code === 10000) {
    //       this.instituteCategoryArr = res.data
    //     }
    //   })
    // },
    getTicketList(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchTicketList(params).then(res => {
        const { total, list = [] } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 列表请求参数
    getParams(otherParams = {}) {
      const { period = [], ...otherSearchParams } = this.search
      let params = { start_date_time: period && period[0], end_date_time: period && period[1], ...otherSearchParams, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },
    onClickAddBtn() {
      this.$refs.addTicketRef.changModalStatus(true)
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      params.page = 0
      this.downloading = true
      fetchDownloadTicketList(params).then(res => {
        this.$message.success('Start downloading!')
        this.handleExlData(res.data).then((downloadData) => {
          exportXlsx(downloadData, 'Ticket_List')
        })
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleExlData(data = []) {
      const rows = [[
        this.$t('customerService.work_order_number'),
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('customerService.business_type'),
        // this.$t('customerService.payment_method'),
        // this.$t('customerService.payment_code'),
        // 'QR Code Id',
        // 'QR Link',
        this.$t('components.amount'),
        this.$t('customerService.customer_phone_number'),
        this.$t('components.transaction_date'),
        this.$t('customerService.description'),
        // this.$t('customerService.cs_intervention_time'),
        // this.$t('customerService.cs_completion_time'),
        // this.$t('customerService.conclusion'),
        this.$t('components.create_time'),
        this.$t('components.status')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']

      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.issue_no,
            tr.merchant_order_id,
            this.getBusinessTypeLabel(tr.operation_type),
            // this.getPaymentMethodLabel(tr.payment_method),
            // tr.account_no,
            // tr.qrcode,
            // tr.qr_link,
            toDivide100(tr.amount),
            tr.phone_no,
            tr.transaction_date,
            tr.issue,

            // tr.cs_intervention_time,
            // tr.cs_completion_time,
            // tr.conclusion,
            tr.create_time,
            this.getTicketStatusLabel(tr.status)
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickSearchBtn() {
      this.getTicketList()
    },
    onClickDetailBtn(row) {
      this.detailId = row.id
      this.showPayDetailModal()
    },
    showPayDetailModal() {
      this.$refs.ticketDetailsModalRef.changModalStatus(true)
    },
    onClickPaginator() {
      this.getTicketList(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },
    onClickReOpenBtn(row) {
      this.detailId = row.id
      this.$refs.reOpenReplyModal.changModalStatus(true)
    }
  }
}
</script>

<style lang="scss">
.ticket-list{
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .btn {
    margin: 0;
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .order-number{
    width: 250px;
  }
  .transTime{
    display: inline-block;
    padding-right: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    font-family: 'Poppins-Medium';
  }
  .dateRange{
    margin-right: 20px;
  }
  .mb10{
    margin-bottom: 10px;
  }
}

</style>
